import axios from 'axios'
import {ref} from 'vue'

// Past this the app continues with the bundled English texts instead of waiting (i18n.js, App.vue)
const LOAD_TIMEOUT = 8000

export default function useTranslations() {
  const api = import.meta.env.VITE_LOCIZE_API
  const project = import.meta.env.VITE_LOCIZE_PROJECT
  const version = import.meta.env.VITE_LOCIZE_VERSION
  const namespace = import.meta.env.VITE_LOCIZE_NAMESPACE

  const translations = ref({})

  const load = async language => {
    const {data} = await axios.get(`${api}/${project}/${version}/${language}/${namespace}`, {timeout: LOAD_TIMEOUT})
    console.info(`received translations for ${language}`)
    translations.value = data
    return translations.value
  }

  return {
    translations,
    load,
  }
}
